export default "dist/images/block-card-plain.ad2484f.png";